// extracted by mini-css-extract-plugin
export default {"header":"Avatars_header__woRn7"};